import React, { Component } from 'react';
import Link from 'gatsby-link';
import $ from 'jquery';

import whiteLogo from '../assets/images/white-logo.svg';
import blackLogo from '../assets/images/purple-black-logo.svg';

import HamburgerButton from './buttons/HamburgerButton';
import MobileMenu from './MobileMenu/MobileMenu';
import DesktopMenu from './DesktopMenu/DesktopMenu';

class Header extends Component {
  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);

    this.state = {
      isOpen: false,
      cssClass: '',
    };
  }

  componentDidMount() {
    $(window).scroll(() => {
      const position = $(window).scrollTop();

      if (position > 40) {
        this.setState({ cssClass: 'in' });
      } else {
        this.setState({ cssClass: '' });
      }
    });
  }

  handleClick() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  render() {
    const { isOpen, cssClass } = this.state;

    return (
      <header className={`Header ${cssClass}`}>
        <div className="container">
          <nav className="Header__nav">
            <Link
              to="/"
              className="brand"
            >
              <img src={isOpen ? blackLogo : whiteLogo} alt="icon" className="defaultIcon" />
              <img src={blackLogo} alt="icon" className="pageIcon" />
            </Link>

            <DesktopMenu />

            <MobileMenu
              isOpen={isOpen}
              onClick={this.handleClick}
            />

            <HamburgerButton
              isOpen={isOpen}
              onClick={this.handleClick}
            />
          </nav>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./src/components/header.js